import React from 'react';
import { EyeIcon, FileCheck2Icon, LayersIcon, MapIcon, RepeatIcon } from 'lucide-react';
import { Bullet, PAD, Panel, Reveal, SlideFrame, SlideHeader, t } from './primitives';
const BENEFITS = [{
  icon: EyeIcon,
  title: 'Visibility',
  description: 'No surprises across markets'
}, {
  icon: LayersIcon,
  title: 'Governance',
  description: 'Persistent access to campaign history and data'
}, {
  icon: FileCheck2Icon,
  title: 'Compliance support',
  description: 'Campaigns stay available beyond local activation windows'
}, {
  icon: MapIcon,
  title: 'Portfolio oversight',
  description: 'View by geography, brand, and campaign type'
}, {
  icon: RepeatIcon,
  title: 'Operational scale',
  description: 'A repeatable model across global and local teams'
}];
export function ControlTowerValue() {
  return <SlideFrame data-id="element-60" data-mp="2wdd6e3blujut">
      <div className={`flex h-full w-full flex-col ${PAD}`} data-id="element-61" data-mp="2wctw98s74zrc">
        <SlideHeader eyebrow="10 — Platform value" title="What Control Tower" accent="brings to LEO" kicker="Snakker for LEO Pharma" data-id="element-62" data-mp="2wfg5rdyndpc7" />

        <div className="mt-[3.2vh] grid min-h-0 flex-1 grid-cols-[1fr_1.5fr] gap-[1.4vw]" data-id="element-63" data-mp="olxh6fxd8fv0">
          <Reveal delay={0.2} className="flex min-h-0" data-id="element-64" data-mp="jn44uqtteuwf">
            <Panel label="The problem it solves" index="A" className="w-full" data-id="element-65" data-mp="eqnfxueskcia">
              <Bullet data-id="element-66" data-mp="9qiyo2627dr0">
                Central teams need to see what is live, where, for which brand, and how
                it performs
              </Bullet>
              <Bullet data-id="element-67" data-mp="4yrh2h4vsid0">
                Campaigns must stay accessible over time for governance and compliance
              </Bullet>
              <Bullet data-id="element-68" data-mp="3s50jkczgd5ta">
                Campaign-by-campaign management creates visibility gaps as Snaks scale
                across brands and affiliates
              </Bullet>
            </Panel>
          </Reveal>

          <div className="grid min-h-0 grid-cols-2 grid-rows-3 gap-[1.1vw]" data-id="element-69" data-mp="3i62pkuj9ck2w">
            {BENEFITS.map((item, index) => {
            const Icon = item.icon;
            return <Reveal key={item.title} delay={0.3 + index * 0.07} className="flex min-h-0" data-id="element-70" data-mp="3dhs5n4eremdm" data-mpi={index}>
                  <div className="flex w-full flex-col justify-center rounded-[0.7vw] border border-white/10 bg-white/[0.035] px-[1.3vw] py-[1.4vh]" data-id="element-71" data-mp="2zkdark5qlme9">
                    <Icon aria-hidden className="h-[clamp(11px,1.35vw,27px)] w-[clamp(11px,1.35vw,27px)] text-[#A26BFF]" data-id="element-72" data-mp="3r96nv90uejjm" />
                    <p className={`${t.lead} mt-[1.1vh] font-semibold leading-[1.15] text-white`} data-id="element-73" data-mp="3iho7oy3wc3qj">
                      {item.title}
                    </p>
                    <p className={`${t.body} mt-[0.7vh] leading-[1.35] text-white/55`} data-id="element-74" data-mp="e2emdhakvlsz">
                      {item.description}
                    </p>
                  </div>
                </Reveal>;
          })}
            <Reveal delay={0.65} className="flex min-h-0" data-id="element-75" data-mp="23hpdjqchgoof">
              <div className="flex w-full flex-col justify-center bg-[#7D38E5] px-[1.3vw] py-[1.4vh]" data-id="element-76" data-mp="1yk7a2fh8j1nt">
                <p className={`${t.label} font-semibold uppercase tracking-[0.2em] text-white/70`} data-id="element-77" data-mp="2d9bwk8v2bs1q">
                  Net effect
                </p>
                <p className={`${t.small} mt-[1.2vh] font-semibold leading-[1.25] text-white`} data-id="element-78" data-mp="1km93hw95o9iv">
                  One place to see, govern, and switch every LEO campaign.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </SlideFrame>;
}